
import { throwError as observableThrowError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

@Injectable()
export class MyCartService {
    constructor(private http: Http) { }
    getCart(customerId): Observable<any> {
        let url = `${environment.api.serviceurl}` + "GetCart?customerid=" + customerId;

        return this.http.get(url).pipe(
            map((response: Response) => {

                let cartData = response.json();
                let t = cartData.GetCartResult;

                let p = ('(' + t + ')');
                let s = eval(p);
                return s;
            }));
    }

    getcart(customerId: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getCart";
        let orderData = customerId;
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    removeOrder(orderid: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "DeleteOrderCart?orderid=" + orderid;
        return this.http.get(url).pipe(
            map((response: Response) => {
                let projectInfo = response.json();
                let t = projectInfo.DeleteOrderCartResult;
                return t;
            }));
    }

    removeorder(customerId: string, orderid: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "deleteOrderCart";
        let orderData = { "customerid": customerId, "stringData": orderid };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    updateOrder(order: any, customerid: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "UpdateOrderCart";
        let orderData = { "customerid": customerid, "orderData": order };
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    private extractdata(res: Response) {
        let body = res.json();
        return body.orderid || {};
    }

    placeOrder(orderId: string, cardInfo: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "PlaceOrder?orderid=" + orderId + "&cardInfo=" + cardInfo;
        return this.http.get(url).pipe(
            map((response: Response) => {
                let projectInfo = response.json();
                let t = projectInfo.PlaceOrderResult;
                return t;
            }));
    }

    placeorder(customerId: string, orderid: string, cardInfo: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "placeOrder";
        let orderData = { "customerid": customerId, "orderid": orderid, "cardInfo": cardInfo };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractdata),
            catchError(this.handleError),);
    }

    setDelay(orderId: string, delayed: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "SetDelay?orderid=" + orderId + "&delayed=" + delayed;
        return this.http.get(url).pipe(
            map((response: Response) => {
                let projectInfo = response.json();
                let t = projectInfo.SetDelayResult;
                return t;
            }));
    }

    setdelay(customerId: string, orderid: string, delayed: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "setDelay";
        let orderData = { "customerid": customerId, "orderid": orderid, "delayed": delayed };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    getSingleOrder(orderId: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "GetSingleOrder?orderid=" + orderId;
        return this.http.get(url).pipe(
            map((response: Response) => {
                let projectInfo = response.json();
                let t = projectInfo.GetSingleOrderResult;
                let p = ('(' + t + ')');
                let s = eval(p);
                return s;
            }));
    }

    getsingleOrder(customerId: string, orderid: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getSingleOrder";
        let orderData = { "customerid": customerId, "stringData": orderid };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    getOrderSummary(orderId: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "GetOrderSummary?orderid=" + orderId;
        return this.http.get(url).pipe(
            map((response: Response) => {

                let projectInfo = response.json();
                let t = projectInfo.GetOrderSummaryResult;
                return t;
            }));
    }

    getorderSummary(customerId: string, orderid: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getOrderSummary";
        let orderData = { "customerid": customerId, "stringData": orderid };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractdata),
            catchError(this.handleError),);
    }

    private extractData(res: Response) {
        let body = res.json();
        if (body.status == "OK") {
            let jsonbody = JSON.parse(body.orderid);
            return jsonbody || {};
        } else {
            observableThrowError(body.message);
            return []
        }
    }

    private handleError(error: any) {
        let errMsg = '';
        if (error.message) {
            errMsg = error.message;
        } else {
            errMsg = error.status ? '${error.status} - ${error.statusText}' : 'Server error';
        }
        return observableThrowError(errMsg);
    }
}